<template>
  <div class="alternativas-container">
    <div class="menu-lateral">
      <router-link to="/" class="menu-lateral-item title selected" v-slot="{}">
        <a @click="toggleSubmenu">
          <div class="flex-container">
            <div>
              <span class="tema">{{ $store.state.temaAlternativa }}</span>
              <span class="subtema">{{ $store.state.subtemaAlternativa }}</span>
            </div>
            <span class="icono-despliegue">
              <img class="arrow-icon" :class="{'rotar':submenu_abierto}" src="data:image/svg+xml;base64,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" alt="" srcset="">
            </span>
          </div>          
        </a>
      </router-link>

      <div class="dropdown" :class="{ 'esta-abierto': submenu_abierto }">
        <router-link
          to="/alternativas"
          class="menu-lateral-item title"
          custom
          v-slot="{ href, isExactActive, navigate }"          
        >
          <a
            :href="href"
            :class="{ active: isExactActive }"
            @click="navigate"
            v-on:click="toggleSubmenu"
          >
            Introducción
          </a>
        </router-link>

        <div class="separador"></div>

        <div class="menu-lateral-item title">
          Principios del Manejo Ecológico Integral de Arvenses (MEIA)
        </div>
        <router-link
          to="/alternativas/principios-manejo-ecologico-arvenses-articulos"
          class="menu-lateral-item"
          custom
          v-slot="{ href, isExactActive, navigate }"
        >
          <a
            :href="href"
            :class="{ active: isExactActive }"
            @click="navigate"
            v-on:click="toggleSubmenu"
          >
            Artículos científicos
          </a>
        </router-link>
        <router-link
          to="/alternativas/principios-manejo-ecologico-arvenses-materiales"
          class="menu-lateral-item"
          custom
          v-slot="{ href, isExactActive, navigate }"
        >
          <a
            :href="href"
            :class="{ active: isExactActive }"
            @click="navigate"
            v-on:click="toggleSubmenu"
          >
            Materiales de divulgación y capacitación
          </a>
        </router-link>
        <router-link
          to="/alternativas/principios-manejo-ecologico-arvenses-manuales"
          class="menu-lateral-item"
          custom
          v-slot="{ href, isExactActive, navigate }"
        >
          <a
            :href="href"
            :class="{ active: isExactActive }"
            @click="navigate"
            v-on:click="toggleSubmenu"
          >
            Manuales
          </a>
        </router-link>

        <div class="separador"></div>

        <div class="menu-lateral-item title">Prácticas específicas del MEIA</div>
        <router-link
          to="/alternativas/practicas-especiales-articulos"
          class="menu-lateral-item"
          custom
          v-slot="{ href, isExactActive, navigate }"
        >
          <a
            :href="href"
            :class="{ active: isExactActive }"
            @click="navigate"
            v-on:click="toggleSubmenu"
          >
            Artículos científicos
          </a>
        </router-link>
        <router-link
          to="/alternativas/practicas-especiales-materiales"
          class="menu-lateral-item"
          custom
          v-slot="{ href, isExactActive, navigate }"
        >
          <a
            :href="href"
            :class="{ active: isExactActive }"
            @click="navigate"
            v-on:click="toggleSubmenu"
          >
            Materiales de divulgación y capacitación
          </a>
        </router-link>
        <router-link
          to="/alternativas/practicas-especiales-mapa"
          class="menu-lateral-item"
          custom
          v-slot="{ href, isExactActive, navigate }"
        >
          <a
            :href="href"
            :class="{ active: isExactActive }"
            @click="navigate"
            v-on:click="toggleSubmenu"
          >
            Mapa uso de maquinaria 2007
          </a>
        </router-link>

        <div class="separador"></div>

        <div class="menu-lateral-item title">
          Experiencias exitosas de transición al MEIA
        </div>
        <router-link
          to="/alternativas/enlaces"
          class="menu-lateral-item"
          custom
          v-slot="{ href, isExactActive, navigate }"
        >
          <a
            :href="href"
            :class="{ active: isExactActive }"
            @click="navigate"
            v-on:click="toggleSubmenu"
          >
            Videos
          </a>
        </router-link>
      </div>
    </div>
    <main class="container">
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
export default {
  name: "Alternativas",
  components: {},
  data() {
    return {
      submenu_abierto: false,
    };
  },
  methods: {
    toggleSubmenu() {
      this.submenu_abierto = !this.submenu_abierto
    }
  },
  computed: {
    isA11yContrast() {
      return this.$store.getters.isA11yContrast;
    },
  },
};
</script>

<style lang="scss">
.alternativas-container {
  display: flex;
  flex-direction: column;
  @media (min-width: map-get($media-queries-limit, "mobile")) {
    flex-direction: row;
    min-height: calc(100vh - 51px);
  }
  .menu-lateral {
    padding-top: 20px;
    background-color: rgba(134, 181, 155, 0.2);
    margin-left: auto;
    margin-right: auto;
    width: calc(100%);
    padding: $gap * .5;
    margin-bottom: $gap;
    @media (min-width: map-get($media-queries-limit, "mobile")) {
      width: calc(100% - 60px);
      max-width: 1024px;
      margin-top: 20px;
      padding: 10px;
      margin-bottom: 0;
    }
    a.selected {
      display: block;
      &:hover {
        background: none;
      }  
      .flex-container {
        display: flex;
        justify-content: space-between;
        position: relative;
        .tema {
          margin-bottom: 8px;
          display: block;
        }
        .subtema {
          font-weight:normal;
        }
        span.icono-despliegue {
          width: 24%;
          img.arrow-icon {
            position: absolute;
            right: 0;
            width: 32px;
            transition: all .3s ease-in-out;
            &.rotar {
              transform: rotate(180deg);
            }
          }
        }
      }
    }
    .dropdown {
      overflow: hidden;
      max-height: 0px;
      transition: all 0.3s ease-in-out;
      &.esta-abierto {
        max-height: 700px;
      }
    }
    @media (min-width: map-get($media-queries-limit, "mobile")) {
      width: 440px;
      margin: 0;
      padding: 16px;
      display: block;
      a.selected {
        display: none;
      }
      .dropdown,
      .dropdown.esta-abierto {
        max-height: inherit;
      }
    }
    .menu-lateral-item.title {
      font-weight: 600;
      padding: 8px 16px;
    }
    a.menu-lateral-item {
      color: black;
      padding: 8px 32px;
      width: 100%;
      &:hover {
        background: #D7E5DD;
      }
      &.active {
        background: rgba(33, 108, 66, 0.5);
        box-shadow: 0 0 0 4px rgba(33, 108, 66, 0.5);
        outline: none;
      }
    }
    .separador {
      width: 100%;
      height: 0px;
      border: 0.5px solid #468161;
      opacity: 0.2;
      margin: 9px 0;
    }
  }
}
</style>
